import * as React from "react";
import { useState } from "react";
import Form from "../commons/components/form/Form";
import { required } from "../commons/model/form/Validators";
import TextAreaInput from "../commons/components/form/input/TextAreaInput";
import NoteActivityAction from "../patient-management/NoteActivityAction";
import sfetch from "../commons/utils/super-fetch";
import InputState from "../commons/model/form/InputState";

export default function AddNoteActivity({
                                          action,
                                          close,
                                        }: {
  action: NoteActivityAction;
  close: () => any;
}) {
  const [errorMessage, setErrorMessage] = useState<string>();

  const createNote = async (formContent: { [key: string]: InputState }) => {
    const content = formContent["note-text-field"].value;
    const payload = {
      content,
    };

    try {
      await sfetch(action.createNoteApiUrl, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      }).then(() => {
        window.onbeforeunload = close
        document.location.reload()
      });
    } catch (error) {
      setErrorMessage(i18n["Global.TechnicalError"]);
      throw error;
    }
  };

  return (
    <Form
      submitLabel={i18n["Activity.Action.Note.Create"]}
      submit={createNote}
      generalErrorMsg={errorMessage}
      secondaryActionLabel={i18n["Activity.Action.Note.Cancel"]}
      secondaryAction={close}
    >
      <TextAreaInput
        name="note-text-field"
        label={i18n["Activity.Action.Note.Content.Label"]}
        placeholder={i18n["Activity.Action.Note.Content.Placeholder"]}
        validators={[required()]}
        maxLength={512}
      />
    </Form>
  );
}
